import { render, staticRenderFns } from "./vCarousel.vue?vue&type=template&id=a73a3218&scoped=true"
import script from "./vCarousel.vue?vue&type=script&lang=ts"
export * from "./vCarousel.vue?vue&type=script&lang=ts"
import style0 from "./vCarousel.vue?vue&type=style&index=0&id=a73a3218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73a3218",
  null
  
)

export default component.exports